import React from 'react';
import MediaQuery from 'react-responsive';

import {
  small,
  smallUp,
  medium,
  mediumUp,
  large,
  largeUp,
  extraLarge,
  landscape,
  portrait,
  retina,
} from 'constants/mediaQueries';

export default MediaQuery;

export const Small = props => <MediaQuery query={small} {...props} />;

export const SmallUp = props => <MediaQuery query={smallUp} {...props} />;

export const Medium = props => <MediaQuery query={medium} {...props} />;

export const MediumUp = props => <MediaQuery query={mediumUp} {...props} />;

export const Large = props => <MediaQuery query={large} {...props} />;

export const LargeUp = props => <MediaQuery query={largeUp} {...props} />;

export const ExtraLarge = props => <MediaQuery query={extraLarge} {...props} />;

export const Landscape = props => <MediaQuery query={landscape} {...props} />;

export const Portrait = props => <MediaQuery query={portrait} {...props} />;

export const Retina = props => <MediaQuery query={retina} {...props} />;
